import React, { useState, useEffect } from 'react'

export const TutorQualityContext = React.createContext({
  dataMap: {},
  criteriaMap: {},
  setPaginatedData: () => {},
  setCriteria: () => {},
  clearStorage: () => {},
  isHydrated: false
})

export const TutorQualityProvider = ({ children }) => {
  const [dataMap, setDataMap] = useState({})
  const [criteriaMap, setCriteriaMapState] = useState({})
  const [isHydrated, setIsHydrated] = useState(false)

  const STORAGE_KEY_DATA = 'tutorQuality_dataMap'
  const STORAGE_KEY_CRITERIA = 'tutorQuality_criteriaMap'

  // Load dữ liệu từ localStorage khi component mount
  useEffect(() => {
    if (typeof window !== 'undefined') {
      try {
        const savedDataMap = localStorage.getItem(STORAGE_KEY_DATA)
        const savedCriteriaMap = localStorage.getItem(STORAGE_KEY_CRITERIA)

        if (savedDataMap) {
          setDataMap(JSON.parse(savedDataMap))
        }
        if (savedCriteriaMap) {
          setCriteriaMapState(JSON.parse(savedCriteriaMap))
        }
      } catch (error) {
        console.error('Lỗi khi load dữ liệu từ localStorage:', error)
      }
      setIsHydrated(true)
    }
  }, [])

  // Lưu dataMap vào localStorage mỗi khi thay đổi
  useEffect(() => {
    if (typeof window !== 'undefined' && isHydrated) {
      try {
        localStorage.setItem(STORAGE_KEY_DATA, JSON.stringify(dataMap))
      } catch (error) {
        console.error('Lỗi khi lưu dataMap vào localStorage:', error)
      }
    }
  }, [dataMap, isHydrated])

  // Lưu criteriaMap vào localStorage mỗi khi thay đổi
  useEffect(() => {
    if (typeof window !== 'undefined' && isHydrated) {
      try {
        localStorage.setItem(STORAGE_KEY_CRITERIA, JSON.stringify(criteriaMap))
      } catch (error) {
        console.error('Lỗi khi lưu criteriaMap vào localStorage:', error)
      }
    }
  }, [criteriaMap, isHydrated])

  const setPaginatedData = (key, data) => {
    setDataMap(prev => ({
      ...prev,
      [key]: data
    }))
  }

  const setCriteria = (key, criteria) => {
    setCriteriaMapState(prev => ({
      ...prev,
      [key]: criteria
    }))
  }

  const clearStorage = () => {
    try {
      localStorage.removeItem(STORAGE_KEY_DATA)
      localStorage.removeItem(STORAGE_KEY_CRITERIA)
      setDataMap({})
      setCriteriaMapState({})
    } catch (error) {
      console.error('Lỗi khi xóa localStorage:', error)
    }
  }

  const value = {
    dataMap,
    criteriaMap,
    setPaginatedData,
    setCriteria,
    clearStorage,
    isHydrated
  }

  return (
    <TutorQualityContext.Provider value={value}>
      {children}
    </TutorQualityContext.Provider>
  )
}
